import { Grid, Theme } from '@mui/material';
import { createStyles, withStyles } from '@mui/styles';
import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import * as routing from '../../../constants/Routing';
import { useRetrieveActiveProject } from '../../../hooks/project/useRetrieveActiveProject';
import eventsPanel, { PageViewPages } from '../../../services/events';
import { SupervisorsList } from './list';
import { SupervisorsStyling } from './styling';

const styles = ({ breakpoints }: Theme) =>
  createStyles({
    divInside: {
      height: `100%`,
      width: `100%`,
      zIndex: 2,
      backgroundColor: `white`,
      display: `flex`,
      flexDirection: `row`,
    },
    divContainer: {
      height: `100%`,
      width: `100%`,
    },
    divContainerData: {
      width: `100%`,
      height: `100%`,
      [breakpoints.down(`sm`)]: {
        width: `100%`,
      },
    },
  });

interface ProjectSettingsSupervisorsProps {
  classes: {
    divInside: string;
    divContainer: string;
    divContainerData: string;
  };
}

export const ProjectSettingsSupervisors = withStyles(styles)(({ classes }: ProjectSettingsSupervisorsProps) => {
  const { data: activeProject } = useRetrieveActiveProject();

  useEffect(() => {
    if (activeProject) {
      eventsPanel.pageView(PageViewPages.supervisors);
    }
  }, [activeProject]);

  if (!activeProject) {
    return null;
  }

  return (
    <div className={classes.divInside}>
      <Grid container className={classes.divContainer} wrap="nowrap">
        <Grid container className={classes.divContainerData} direction="column" wrap="nowrap">
          <Routes>
            <Route
              index
              element={
                <Navigate
                  to={routing.PROJECT_SETTINGS.SUPERVISORS.LIST.replace(`:projectId`, activeProject!.id ?? ``)}
                />
              }
            />

            <Route path="/list" element={<SupervisorsList />} />
            <Route path="/styling" element={<SupervisorsStyling />} />

            <Route
              path="*"
              element={
                <Navigate to={routing.PROJECT_SETTINGS.SUPERVISORS.LIST.replace(`:projectId`, activeProject!.id)} />
              }
            />
          </Routes>
        </Grid>
      </Grid>
    </div>
  );
});
